





























































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import TranslationsMixins from "@/mixins/translations";

// Enums/Data
import { PromotionTypes } from "@/data/enums/promotions";

// Functions
import { geterateRandomString } from "@/helpers/generateCode";

// Types
import { IPromotion, IPromotionForm } from "@/models/promotions";
import { IBrand } from "@/models/brands";
import { DataModules } from "@/store/modules/data";

@Component
export default class BasicConfiguration extends Mixins(
  HasValidation,
  TranslationsMixins
) {
  // Props
  @Prop({ default: null })
  public promotion!: IPromotion | null;

  @Prop({ required: true })
  public value!: IPromotionForm;

  @Prop({ required: true })
  public isDisabled!: boolean;

  // Data
  public promotionType: PromotionTypes = PromotionTypes.GLOBAL;
  public promotionTypes = PromotionTypes;
  public form = this.$_.cloneDeep(this.value);
  public unwatchPromtionType: () => void = () => {
    return;
  };
  public state = {
    global: undefined,
    selected: undefined,
    individual: undefined
  } as {
    global?: IPromotionForm;
    selected?: IPromotionForm;
    individual?: IPromotionForm;
  };

  // Lifecycle methods
  public created() {
    this.reinitiatePromotionType();
    this.unwatchPromtionType = this.$watch(
      "promotionType",
      this.onPromotionTypeChange
    );
  }

  public get isUpdate() {
    return !this.$_.isEmpty(this.promotion);
  }

  public get canTranslatePromotions() {
    return this.$userCan("update_promotion") && this.isUpdate;
  }

  public get promotionProducts() {
    return this.value.products;
  }

  // Methods
  public generateCode() {
    if (this.isDisabled) return;
    this.$set(this.form, "code", geterateRandomString(8));
  }

  public translateField(props) {
    if (this.isDisabled) return;
    this.openTranslateModal({
      objectId: this.promotion?.id as IPromotion["id"],
      objectTypeCode: this.translationsTypes.PROMOTION,
      brandId: this.promotion?.brand_id as IBrand["id"],
      fieldType: "text",
      ...props
    });
  }

  public reinitiatePromotionType() {
    this.promotionType = this.$store.getters[
      `data/${DataModules.CATALOGUE_PROMOTIONS}/getPromotionType`
    ](this.form);
  }

  public resetState() {
    this.unwatchPromtionType();
    this.state.global = undefined;
    this.state.individual = undefined;
    this.state.selected = undefined;
    this.reinitiatePromotionType();
    this.unwatchPromtionType = this.$watch(
      "promotionType",
      this.onPromotionTypeChange
    );
  }

  public onPromotionTypeChange(promotionType, oldVal) {
    // Save state before changing
    if (oldVal === PromotionTypes.GLOBAL)
      this.state.global = this.$_.cloneDeep(this.form);
    else if (oldVal === PromotionTypes.SELECTED_PRODUCTS)
      this.state.selected = this.$_.cloneDeep(this.form);
    else if (oldVal === PromotionTypes.INDIVIDUAL)
      this.state.individual = this.$_.cloneDeep(this.form);

    if (PromotionTypes.GLOBAL === promotionType) {
      if (this.state.global) {
        this.form = this.state.global;
      } else {
        this.form.global = true;
        this.form.constant_discount = false;
        this.form.products = [];
      }
    } else if (PromotionTypes.SELECTED_PRODUCTS === promotionType) {
      if (this.state.selected) {
        this.form = this.state.selected;
      } else {
        this.form.global = false;
        this.form.constant_discount = true;
        this.form.products = [];
      }
    } else if (PromotionTypes.INDIVIDUAL === promotionType) {
      if (this.state.individual) {
        this.form = this.state.individual;
      } else {
        this.form.global = false;
        this.form.constant_discount = false;
        this.form.products = [];
      }
    }
  }

  @Watch("value", { deep: true })
  public onValueChange(newVal) {
    this.form = newVal;
  }

  @Watch("form", { deep: true })
  public onFormChange(newVal) {
    this.$emit("input", newVal);
  }
}
